import React from "react";
import { SocCompleteIcon } from "../Icons";
import SocCustomAvatar from "../../shared/containers/StandardOfCareContainer/SocCustomAvatar";
import { fromUnixToMonthDay } from "../../utils/unix-timestamp";

interface MonthItemProps {
  monthName: string;
  monthIndex: number;
  year: string;
  status: boolean;
  isGrayedOut: boolean;
  currentMonthIndex: number;
  selected: boolean;
  onClick: () => void;
  fulfilledDate: number | null;
}

const MonthItem: React.FC<MonthItemProps> = ({
  monthName, monthIndex, status, isGrayedOut, year, currentMonthIndex, selected, onClick, fulfilledDate,
}) => {
  const currentYear = String(new Date().getFullYear());

  const getOverdueStatus = () => {
    if (monthIndex < currentMonthIndex && year === currentYear) return "Overdue";
    if (monthIndex === currentMonthIndex && year === currentYear) return "Almost Due";

    return "default";
  };

  const statusType = getOverdueStatus();
  const getStatusClass = () => {
    let baseClass = "py-1 rounded-lg text-center h-full";

    if (selected) baseClass += " cursor-pointer border border-gv-yellow bg-gv-yellow-light p-[1.2rem]";
    else if (statusType !== "default" &&
      !status && year === currentYear) baseClass += " cursor-pointer border border-gray-3 p-[1.2rem]";

    return baseClass;
  };

  return (
    <div
      className={`relative carousel-item w-1/5 p-2 px-4 ps-2 text-sm ${isGrayedOut ? "text-gray-400" : ""}`}
      onClick={!status && !isGrayedOut ? onClick : undefined}
    >
      {fulfilledDate && (
        <div className="cursor-pointer text-xs text-gray-1 z-100 bg-white
        absolute flex flex-col items-center gap-2 p-2 rounded-xl opacity-0 hover:opacity-100">
          <div>Fulfilled:</div>
          <div>{fromUnixToMonthDay(fulfilledDate)}</div>
        </div>
      )}
      <div className={getStatusClass()}>
        <div className={`flex flex-col items-center gap-2
          ${monthIndex < currentMonthIndex && !selected ? "opacity-40" : ""}`}>
          {status ?
            <SocCompleteIcon height={20} width={20} /> :
            <SocCustomAvatar type={statusType} height={21} width={21} />}
          <div>{monthName.slice(0, 3)}</div>
        </div>
      </div>
    </div>
  );
};

export default MonthItem;
